import Nav from "@/components/Nav";
import Hero from "@/components/sections/Hero";
import MarqueeStrip from "@/components/sections/MarqueeStrip";
import BrandSplit from "@/components/sections/BrandSplit";
import Manifesto from "@/components/sections/Manifesto";
import LeadCapture from "@/components/sections/LeadCapture";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#050505] text-[#f5f5f5]">
      <Nav />
      <Hero />
      <MarqueeStrip />
      <BrandSplit />
      <Manifesto />
      <LeadCapture />
      <Footer />
    </main>
  );
}
